/* INHUMANE — theme interactions */
(function () {
  'use strict';

  // ---- Mobile nav ----
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
      const open = nav.classList.contains('open');
      toggle.setAttribute('aria-expanded', open);
      document.body.style.overflow = open ? 'hidden' : '';
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ---- Accordions (FAQ, size guide sections) ----
  document.querySelectorAll('[data-acc-q]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const item = btn.closest('[data-acc-item]');
      const panel = item.querySelector('[data-acc-a]');
      const isOpen = item.classList.toggle('open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
      btn.setAttribute('aria-expanded', isOpen);
    });
  });

// ---- PDP variant selection ----
  var variantGroup = document.querySelector('[data-variant-group]');
  var variantInput = document.getElementById('pdpVariantId');
  if (variantGroup && variantInput) {
    variantGroup.querySelectorAll('.swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        if (sw.hasAttribute('disabled')) return;
        variantGroup.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('sel'); });
        sw.classList.add('sel');
        variantInput.value = sw.getAttribute('data-variant-id');
        var priceEl = document.querySelector('.pdp__price');
        if (priceEl && sw.getAttribute('data-price')) { priceEl.textContent = sw.getAttribute('data-price'); }
      });
    });
  }

  // ---- Scroll reveal ----
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.style.opacity = 1; e.target.style.transform = 'none'; io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = 0;
      el.style.transform = 'translateY(28px)';
      el.style.transition = 'opacity .7s ease, transform .7s ease';
      io.observe(el);
    });
  }

  // ---- Newsletter (front-end guard only; Shopify handles the real submit) ----
  document.querySelectorAll('[data-cult-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      const btn = form.querySelector('button');
      if (btn) { btn.textContent = 'Bound.'; }
    });
  });
// ---- PDP gallery thumbnails ----
  var pdpMain = document.getElementById('pdpMainImage');
  if (pdpMain) {
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        pdpMain.src = thumb.getAttribute('data-full');
        document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) { t.classList.remove('sel'); });
        thumb.classList.add('sel');
      });
    });
  }})();
